import axios from "axios";
import { toast } from "sonner";

const envUrl = process.env.REACT_APP_BACKEND_URL;
// Same-origin when served from a custom domain (avoids CORS + third-party cookies); env URL otherwise.
export const API_BASE = new URL(envUrl).host === window.location.host ? envUrl : window.location.origin;

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
export const toastErr = (e) => toast.error(errMsg(e));
